import { render, staticRenderFns } from "./CoozzyCalendarIcon.vue?vue&type=template&id=6effeb9f&scoped=true"
import script from "./CoozzyCalendarIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyCalendarIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyCalendarIcon.vue?vue&type=style&index=0&id=6effeb9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6effeb9f",
  null
  
)

export default component.exports